module.exports = __webpack_public_path__ + "img/snv-demon.2fe55248.png";